module.exports = __webpack_public_path__ + "2b71205a22f2dca262a8a747a024363e.fbx";